import * as React from 'react';

import { IBuilder, ISeller } from '../../types/newbuildingsCompare';
import { PhoneButton } from '../../components/NewbuildingCallToAction/PhoneButton';
import { useDialPhone } from './useDialPhone';

export interface ICallButtonProps {
  newbuildingId: number;
  url: string;
  target: IBuilder | ISeller;
  isBuilder: boolean;
  onlyIcon?: boolean;
}

/** Одиночный контакт: тап по кнопке сразу уходит в `tel:`. */
export const CallButton: React.FC<ICallButtonProps> = ({ newbuildingId, url, target, isBuilder, onlyIcon }) => {
  const dial = useDialPhone({ newbuildingId, url, target, sellerType: isBuilder ? 'builders' : 'agents' });

  return <PhoneButton onlyIcon={onlyIcon} onClick={dial} />;
};
